$( document ).ready(function() {
    var checkExist = setInterval(function() {
        var $item = $('[data-cf-form] .cf-field:not(.c-pop-up-book-now__bottom--form-field):not([data-cf-field-type="checkbox"]):not([data-cf-field-type="email_marketing_consent"]');
        if ($item.length) {
           clearInterval(checkExist);
            $('.cf-field:not(.c-pop-up-book-now__bottom--form-field):not([data-cf-field-type="checkbox"]):not([data-cf-field-type="email_marketing_consent"]').append('<div class="input__box"></div>');
            $('.cf-field:not(.c-pop-up-book-now__bottom--form-field):not([data-cf-field-type="checkbox"]):not([data-cf-field-type="email_marketing_consent"]').each(function(){
                var $label = $(this).find('label');
                var $input = $(this).find('input');
                var $inputBox = $(this).find('.input__box');
                $inputBox.append($input);
                $inputBox.append($label);
                var $dataID = $(this).data('cf-field-id');
                //$('.cf-field[data-cf-field-type="checkbox"]').find('label.cf-enum-field__choice').attr('for',$dataID);
            })

            $('select[placeholder="Day"] option').first().text('DD');
            $('select[placeholder="Month"] option').first().text('MM');
            $('select[placeholder="Year"] option').first().text('YY');

            $('select[placeholder="Day"]').parents('.cf-select-wrap').append('<label>DD*</label>');
            $('select[placeholder="Month"]').parents('.cf-select-wrap').append('<label>MM*</label>');
            $('select[placeholder="Year"]').parents('.cf-select-wrap').append('<label>YYYY*</label>');

        }
    }, 100); // check every 100ms
});